import styled from "styled-components";
import {
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	FONT_WT_REGULAR,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_BORDER_INPUT,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const OfficeWrapper = styled.div`
	padding-bottom: 50px;
	padding-top: 50px;

	.locationContainer {
		display: flex;

		section {
			flex: 1;
			padding-top: 50px;
			position: relative;
		}

		.sanLocation {
			background-image: url(${(props) =>
				props.officeLocations[0].backgroundImage.image});
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center center;
			flex-direction: row-reverse;
			display: flex;
			img,
			& img {
				position: absolute;
				left: -100px;
				bottom: 0;
				width: 190px;
			}
		}

		.bangaloreLocation {
			background-image: url(${(props) =>
				props.officeLocations[1].backgroundImage.image});
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center center;
			img,
			& img {
				position: absolute;
				right: -80px;
				bottom: 0;
				width: 190px;
			}
		}

		.addressBox {
			background-color: white;
			box-shadow: 6px 6px 40px 0 ${COLOR_BORDER_INPUT};
			width: 60%;
			padding: 100px 50px 100px 50px;
			margin: 5px;
			position: relative;
		}

		.addressTitle {
			font-weight: ${FONT_WT_REGULAR};
		}
		h3 {
			font-size: 24px;
		}
		@media only screen and (min-width: ${540 + 1}px) and (max-width: ${1024 -
			1}px) {
			flex-direction: column;

			.sanLocation {
				display: block;
			}
			.bangaloreLocation {
			}
			.addressBox {
				margin: auto;
			}
		}
		@media only screen and (max-width: ${540}px) {
			flex-direction: column;
			.sanLocation {
				display: block;
				img,
				& img {
					width: 100px;
					left: -20px;
				}
			}
			.bangaloreLocation {
				img,
				& img {
					right: -20px;
					width: 100px;
				}
			}
			.addressBox {
				margin: auto;
				width: 90%;
			}
		}
	}

	.ft-18px {
		font-size: 18px;
	}

	p {
		line-height: 27px;
		font-weight: ${FONT_WT_LIGHT};
		margin: 0 0 10px;
	}

	h2 {
		font-size: 30px;
	}

	p,
	h3,
	h2 {
		text-align: center;
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	h2,
	h3 {
		font-weight: ${FONT_WT_MEDIUM};
	}
`;
